import { rankOf, suitOf, type Card } from '@cribbage/engine';
import type { TFunction } from 'i18next';

/**
 * The one place a card becomes words.
 *
 * Feeds `t('a11y.cardLabel')` — "{{rank}} of {{suit}}" — from the
 * `card.rank.*` / `card.suit.*` keys in `en.json`. The e2e suite navigates by
 * these exact names ("ace of spades"), so the English values of those keys are
 * a contract: rename one and Playwright loses the hand buttons.
 */
export function cardName(t: TFunction, card: Card): string {
  return t('a11y.cardLabel', {
    rank: rankName(t, card),
    suit: t(`card.suit.${suitOf(card)}`),
  });
}

/** A card's rank as a word, from the same `card.rank.*` keys: "four", "queen". */
export function rankName(t: TFunction, card: Card): string {
  return t(`card.rank.${rankOf(card)}`);
}

/** Cards in the order given, each by its name, joined with commas. */
export function cardList(t: TFunction, cards: readonly Card[]): string {
  return cards.map((card) => cardName(t, card)).join(', ');
}
